var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"small mb-0"},[_vm._v(" From "+_vm._s(_vm.transaction.transactionType.source.description)+" "),(_vm.destination)?_c('span',[_vm._v("to "+_vm._s(`${_vm.transaction.walletShare.wallet.information.alias} (${_vm.transaction.walletShare.wallet.information.bankAccount})`))]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }